import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormControlName, FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ControlMessage } from '@config/enum/control-message.enum';
import { UtilitiesService } from '@services/utilities.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-input-text',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss'],
})
export class InputTextComponent implements OnInit {
  @Input() textArea: boolean;
  @Input() label: string;
  @Input() required = false;
  @Input() placeholder: string;
  @Input() absControl: AbstractControl;
  @Input() min?: string;
  @Input() max?: string;
  @Input() inputClass?: string;
  @Input() class?: string;
  @Input() pattern?: string | RegExp;
  @Input() type?: string;
  @Input() columnStacked = false;

  @Input() extraContent = false;

  valueFormGroup: FormGroup;
  valueFormControl?: FormControl;

  // ControlMessage: ControlMessage
  VALIDATOR_CONTROL = ['required', 'min-length', 'max-length', 'pattern', 'email', 'email-unique'];

  constructor(private formGroupDirective: FormGroupDirective, private formControlNameDirective: FormControlName, private utilitiesService: UtilitiesService) {}

  ngOnInit() {
    this.valueFormGroup = this.formGroupDirective.form;
    this.valueFormControl = this.formGroupDirective.getControl(this.formControlNameDirective);
  }

  get controlName() {
    return this.formControlNameDirective.name;
  }

  get isNotValidAndDirty() {
    return !this.formControlNameDirective.valid && this.formControlNameDirective.dirty;
  }

  get hasErrors() {
    return this.formControlNameDirective.errors;
  }

  get enabled() {
    return this.valueFormControl?.enabled;
  }

  displayErrorMessage(name?: any, type: string = '') {
    const hasType = this.VALIDATOR_CONTROL.includes(type);

    if (!type || !hasType) {
      return;
    }

    const _name = this.utilitiesService.mapKeyToString(ControlMessage, name);

    // return message
    return this.pleaseMapErrorType(type, _name);
  }

  pleaseMapErrorType(type: string, name: string) {
    let _result = `${name} `;

    switch (type) {
      case 'required':
        _result += 'harus diisi';
        break;
      case 'max-length':
        _result += `tidak boleh melebihi ${this.max} karakter`;
        break;
      case 'email-unique':
        _result = `Alamat email sudah terdaftar`;
        break;
      default:
        _result += 'tidak sesuai';
        break;
    }

    return _result;
  }
}
